module.exports = {"id":"s6-q4","text":"Are you comfortable accessing information on your phone using apps or a web browser?","multiselect":false,"options":[{"id":"s6-q4-a1","text":"Yes","next":"s6-q5","capability":2,"access":1,"focusarea":[3,0,0,0,3]},{"id":"s6-q4-a2","text":"No","next":"finish","capability":-4,"access":-4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q4.json
// module id = 932
// module chunks = 32